import styled from "styled-components";
import { useState } from "react";
import { useLayout } from "src/utils/hooks/useLayout";
import { CollapsibleAdUnit } from "src/components/CollapsibleAdUnit/CollapsibleAdUnit";
import { useFeature } from "src/feature/useFeature";
import { RefreshingAd } from "src/components/RefreshingAd/RefreshingAd";
import { spacing } from "../../../theme";

const RouteScreenLayouts = {
  mobile: ["singleMobile", "singleMobile2"],
  tablet: ["routeScreen", "routeScreen2"],
  desktop: ["routeScreen", "routeScreen2"],
} as const;

export function RouteScreenAds() {
  const layout = useLayout();
  // We want to keep track of the initial state of the ad because
  // we don't want to rerequest the ad if the layout changes.
  const [[firstAd, secondAd], _] = useState(RouteScreenLayouts[layout]);
  const refreshAdUnits = useFeature("RefreshAdUnits");
  const AdComponent =
    layout === "mobile" && refreshAdUnits ? RefreshingAd : CollapsibleAdUnit;

  return (
    <Wrapper>
      <AdComponent variant="DisplayAd" slotConfigId={firstAd} />
      <StyledCollapsibleAdUnit variant="CsaAd" />
      <AdComponent variant="DisplayAd" slotConfigId={secondAd} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${spacing.xl};
  align-items: center;
  margin-bottom: ${spacing.xxl};

  padding-top: ${spacing.xxxl};
`;

const StyledCollapsibleAdUnit = styled(CollapsibleAdUnit)<{
  hide?: boolean;
}>`
  margin-inline: ${spacing.sm};
  align-self: stretch; // The CSA ad can be wider
`;
